// ===================================================================
// KAIXO - GroupCalls API client
// ===================================================================
// Cliente axios para los endpoints /api/group-calls/*. Aislado del
// services/api.js general — el módulo de llamadas grupales no aparece
// en ninguna otra parte del frontend (el componente que lo usa lo
// importa explícitamente).
// ===================================================================

import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://backend-dlmm.onrender.com/api';

// Reusamos el mismo interceptor de auth que el resto: leemos el JWT del
// localStorage en cada request. Los endpoints exigen `resolveUserId`
// que hoy acepta tanto JWT en Authorization como x-user-id legacy.
const api = axios.create({
    baseURL: `${API_URL}/group-calls`,
    withCredentials: false
});

api.interceptors.request.use((config) => {
    try {
        const token = localStorage.getItem('kaixo_token');
        if (token) config.headers.Authorization = `Bearer ${token}`;
        const userStr = localStorage.getItem('kaixo_user');
        if (userStr) {
            const u = JSON.parse(userStr);
            if (u?._id) config.headers['x-user-id'] = u._id;
        }
    } catch {}
    return config;
});

export const initiateGroupCall = ({ groupId, type = 'voice' }) =>
    api.post('/initiate', { groupId, type });

export const joinGroupCall = (callId) =>
    api.post(`/${callId}/join`);

export const leaveGroupCall = (callId) =>
    api.post(`/${callId}/leave`);

export const declineGroupCall = (callId) =>
    api.post(`/${callId}/decline`);

export const canStartGroupCall = (groupId) =>
    api.get(`/groups/${groupId}/can-start`);
